import { FC } from 'react';
import styled from 'styled-components';

// borders on table rows are unfortuantely unstyleable- so we have to apply it to the cells
const StyledBaseCell = styled.div<{
  $textAlign?: string;
  $verticalAlign?: string;
  $minWidth?: number;
  $maxWidth?: number;
}>`
  border-style: solid;
  border-width: 0;
  border-bottom-color: #d6d6d6;
  border-bottom-width: 1px;
  box-sizing: border-box;
  display: table-cell;
  margin: 0;
  ${({ $maxWidth }) => ($maxWidth ? `max-width: ${$maxWidth}px;` : ``)}
  ${({ $minWidth }) => ($minWidth ? `min-width: ${$minWidth}px;` : ``)}
  overflow-y: visible;
  padding: 15px;
  ${({ $textAlign }) => ($textAlign ? `text-align: ${$textAlign};` : ``)}
  vertical-align: ${({ $verticalAlign }) => $verticalAlign || 'top'};

  :first-child {
    border-left-width: 1px;
    border-left-color: #d6d6d6;
  }

  :last-child {
    border-right-width: 1px;
    border-right-color: #d6d6d6;
  }
`;

type Props = {
  /** Horizontal alignment of cell */
  textAlign?: string;
  /** Vertical alignment of cell */
  verticalAlign?: string;
  /** Min width of column. (Pixels) */
  minWidth?: number;
  /** Max width of column. (Pixels) */
  maxWidth?: number;
  /** Width of the cell. Overrides minWidth and maxWidth. */
  width?: number;
};

export const BaseCell: FC<React.PropsWithChildren<Props>> = ({
  children,
  textAlign,
  verticalAlign,
  width,
  minWidth,
  maxWidth,
  ...props
}) => (
  <StyledBaseCell
    data-role="cell"
    $textAlign={textAlign}
    $verticalAlign={verticalAlign}
    $minWidth={width || minWidth}
    $maxWidth={width || maxWidth}
    {...props}
  >
    {children}
  </StyledBaseCell>
);
